<div class="mat-small-header mb-2 px-3">Workflow Steps</div>
<mat-list class="pt-0 border-top">
  <mat-list-item *ngFor="let step of workflow" class="border-bottom">
    <div class="w-100">
      <div class="w-100 d-flex align-items-center p-2" style="font-size: 0.9em;">
        <mat-checkbox class="mat-checkbox-display mat-checkbox-no-margin mr-3" [checked]="isExecuted(step)"></mat-checkbox>
        <mat-chip [ngClass]="getStatusColorBackground(step)" class="mr-2 button-text">
          <mat-icon class="mr-1">{{ getStatusIcon(step) }}</mat-icon>
          {{ getStatusText(step) }}
        </mat-chip>
        <b>{{ getName(step) }} </b>
        <div class="ml-auto"></div>
        <div class="small" *ngIf="isScheduled(step)">
          Scheduled on <b>{{ (step.dateSchedulingComplete | date: 'MM/dd/yyyy') ?? 'Unknown Date' }}</b>
        </div>
        <div class="ml-2 small" *ngIf="isExecuted(step)">
          Completed on <b>{{ (getDateExecuted(step) | date: 'MM/dd/yyyy') ?? 'Unknown Date' }}</b>
        </div>
      </div>
    </div>
  </mat-list-item>
  <mat-list-item *ngIf="workflow.length === 0" class="prereq-item text-center text-muted">
    This work order has no workflow steps.
  </mat-list-item>
</mat-list>